export default [
	{
		ID: "6c6ac4fe-58e9-42e4-9f2e-7a49d819a4d8",
		trigger: "loblaws2022-welcome",
	},
	{
		ID: "8ce549a5-0052-46bd-ab88-63b22890cfd7",
		trigger: "IWD2022-scav"
	},
	{
		ID: "a8e682b9-e97c-4098-80de-07d1c6d4a78a",
		trigger: "jenny-network"
	},
	{
		ID: "a8a62aea-4964-434e-ae11-643e96946d98",
		trigger: "IWD2022-hashtags"
	},
	{
		ID: "3d44a22d-ec16-4625-a7e3-a0b4cfc644a5",
		trigger: "she-session"
	},
	{
		ID: "e7bbc593-5660-4d34-9b1d-a2df785d3072",
		trigger: "mentoring"
	},
	{
		ID: "5c5453ef-bcf2-430b-8870-0a01b0e07989",
		trigger: "ceo"
	},
	{
		ID: "bb0388ac-18b6-4ea4-a6cb-925fd7cb391b",
		trigger: "wxn-fireside"
	},
	{
		ID: "ce30834d-facf-4723-b134-8f8bc0e7bfa6",
		trigger: "teams-12-1"
	},
	{
		ID: "7ae5b4b5-2f34-4be9-85d1-528c9f062472",
		trigger: "teams-1-2"
	},
	{
		ID: "b95c98f1-b8b2-4e8e-80b5-d2918eb9fc1c",
		trigger: "teams-4-5"
	},
	{
		ID: "c7575852-aebb-44c7-8c1c-69c902c130be",
		trigger: "building-your-biz"
	},
	{
		ID: "4ce4efce-e7ed-420b-8e8d-de5a8c362ce5",
		trigger: "vod-clue"
	},
	{
		ID: "09907534-e1ea-4fef-b941-707641bd8df7",
		trigger: "bias-market-break"
	},
	{
		ID: "52efbb6e-cb45-4e2c-994a-0e1e70effe6c",
		trigger: "spotlight"
	},
	{
		ID: "85938cb7-8a9c-461d-b09d-6d87f18c0a08",
		trigger: "roots"
	},
	{
		ID: "7fe930b1-9a71-43b1-ab74-1129c77f5f3c",
		trigger: "power-of-info"
	},
	{
		ID: "b6e2d6d7-22dc-4e54-a2ab-7f4f3be3dad1",
		trigger: "parenting"
	},
	{
		ID: "ca27ce0d-1675-46a3-9ae5-39e46c5ebd04",
		trigger: "neurodiversity"
	},
	{
		ID: "9fba2732-1010-4acc-9353-9fc31fa92f1f",
		trigger: "weed"
	},
	{
		ID: "79a647a2-c88e-482f-bf22-77b57d216850",
		trigger: "covid"
	},
	{
		ID: "41b50cc0-e9f1-4992-a2ea-dfe5744b7d14",
		trigger: "beep"
	},
	{
		ID: "2daf5a46-c88a-496d-9395-5ccbb808168e",
		trigger: "allyship"
	},
	{
		ID: "b99a026b-3160-4650-acdc-b2f28087b6cf",
		trigger: "lobby-clue"
	},
	{
		ID: "3eb3e70c-8f82-4d03-9889-72d8012f2a31",
		trigger: "trivia-eng"
	},
	{
		ID: "d769c71d-6f1c-4697-8b82-688c69a08a3d",
		trigger: "trivia-french"
	},
	{
		ID: "c0b563b6-a338-417e-a8a6-7b1765abb58a",
		trigger: "mosaic"
	},
	{
		ID: "83a97c00-1690-4a35-a1d5-1fa6954ac0b0",
		trigger: "photobooth"
	},
	{
		ID: "0e74f763-8bc5-4d04-8d64-fe5452734087",
		trigger: "trans"
	},
	{
		ID: "a424307f-dd11-45ae-887f-c3614fac30b2",
		trigger: "closing"
	},
	{
		ID: "e8b86303-8f13-4b8f-9ac4-7d1ee915bb08",
		trigger: "beauty"
	},
	{
		ID: "b9d31690-4dee-4c81-b616-9f0e2c1178d9",
		trigger: "operations"
	},
	{
		ID: "58a5beab-1028-4b5f-8cb1-f0725e0a504c",
		trigger: "discount"
	},
	{
		ID: "e1d42618-2f03-48c6-a6a7-152529e0e21b",
		trigger: "battling-cultural-bias"
	},
	{
		ID: "1af31287-3ca1-4a28-a74a-a42e13de8b83",
		trigger: "market-division"
	},
	{
		ID: "93fbf30b-9a70-447e-bbf0-ddd7c82e7ca3",
		trigger: "opening-remarks"
	},
	{
		ID: "5c59465a-944b-48c4-9b2a-508c485b88f9",
		trigger: "welcome-session"
	},
	{
		ID: "907a27db-7ba7-4316-89d1-16df039847f0",
		trigger: "fireside"
	},
	{
		ID: "95705021-38e8-4873-8149-27d3efad95f7",
		trigger: "transcending-gender"
	},
	{
		ID: "9adcedf8-386e-410d-8b83-58889b9f85a8",
		trigger: "founders-circle"
	},
	{
		ID: "a5e1080e-e0b6-4b8d-b269-7eb97711f21c",
		trigger: "allyship-mentorship"
	},
	{
		ID: "3602942b-7032-4c51-8d13-03a638e3ef1f",
		trigger: "closed-1"
	},
	{
		ID: "2ebb8ce5-dbde-42c2-803f-3812bb5f34d9",
		trigger: "closed-2"
	},
	{
		ID: "3fdbe9b9-4449-459d-8487-bc9e3402cc28",
		trigger: "closed-3"
	},
	{
		ID: "ed53bf5f-48c6-40a6-89a0-65cb309c8394",
		trigger: "closed-4"
	},
	{
		ID: "c5c9bdd8-dc21-43f1-9df2-2ee455c615ac",
		trigger: "allyship-mentorship"
	},
	{
		ID: "cabf330a-3360-460c-b4fa-4ac4425dc46b",
		trigger: "informal-networks"
	},
]